import React, { Component } from 'react';
import { connect } from 'react-redux';

import { errorHandler, getErrorMessage } from '../../util/responseUtil';
import { STATUS_TICKET_CONSTANT } from '../../constants/statusTicketConstant';
import { CheckPermissionComponent } from '../../util/permission';
import { TICKET_LIST_ALL_REOPEN_UPDATE_ASSGINEE } from '../../constants/menuPermissionConstant';
import API_TICKET_LIST from '../../api/apiTicketList';
import IconReopen from '../../assets/icons/IconReopen';
import Alert from '../Alert/Alert';
import ActionType from '../../redux/reducer/globalActionType';

class TicketReopen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showConfirmAlert: false,
            showErrorAlertResponse: false,
            errorMessage: ''
        }
    }

    handleReopenTicket = () => {
        const updatedAt = {
            updated_at: this.props.data.updated_at
        }

        API_TICKET_LIST.putDataReopenTicket(updatedAt, this.props.data.id, this.props.token)
            .then(res => {
                this.setState({ showConfirmAlert: false })
                setTimeout(() => this.setState({ showSuccessAlert: false }), 1500)
                this.props.getTicketDetail()
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true,
                    showConfirmAlert: false
                })
            }))
    }

    render() {
        return (
            <CheckPermissionComponent permissionConstant={[TICKET_LIST_ALL_REOPEN_UPDATE_ASSGINEE]} userPermission={this.props.userDetail.permissions}>
                <button type="button" id="btnreopen" className={this.props.data.status === STATUS_TICKET_CONSTANT.ON_HOLD ? "bg-white text-darkblue flex items-center rounded-lg focus:outline-none py-2 px-5 mx-1" : "hidden"} onClick={() => this.setState({ showConfirmAlert: true })}>
                    <IconReopen />
                    <span className="ml-1">Ubah Tiket</span>
                </button>
                <Alert show={this.state.showConfirmAlert} icon="warning" button={true} title="Apakah Anda yakin melanjutkan tiket ini?" close={() => this.setState({ showConfirmAlert: false })} submit={() => this.handleReopenTicket()} />
                <Alert show={this.state.showErrorAlertResponse} icon="warning" title={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
            </CheckPermissionComponent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TicketReopen);